// extracted by mini-css-extract-plugin
module.exports = {"neighbourhoods-items-container":"NeighbourhoodsItems_neighbourhoods-items-container__xHZH_"};